// Trustpilot Score en Reviews Extractor uit Specifieke HTML
(function () {
    // Variabele om bij te houden of de injectie al is uitgevoerd
    let injectionPerformed = false;

    // Functie om score en aantal reviews uit de specifieke HTML structuur te halen
    function extractTrustpilotData() {
        // Zoek de specifieke div met Trustpilot informatie
        const trustpilotElement = document.querySelector('#CustomReviewSlider_Col1 .TP-text p');

        if (!trustpilotElement) {
            console.warn('Trustpilot element niet gevonden');
            return { score: "0", reviewsCount: "0" };
        }

        const text = trustpilotElement.textContent.trim();
        console.log('Gevonden Trustpilot tekst:', text);

        // Regex om score en aantal reviews te extraheren
        // Zoekt naar patronen zoals "4,7/5" en "1540 beoordelingen"
        const scoreRegex = /(\d+[,\.]\d+)\/5/;
        const reviewsRegex = /meer dan (\d+) beoordelingen/;

        let score = "0";
        let reviewsCount = "0";

        // Score extraheren
        const scoreMatch = text.match(scoreRegex);
        if (scoreMatch && scoreMatch[1]) {
            // Vervang komma door punt voor internationale notatie
            score = scoreMatch[1].replace(',', '.');
        }

        // Aantal reviews extraheren
        const reviewsMatch = text.match(reviewsRegex);
        if (reviewsMatch && reviewsMatch[1]) {
            reviewsCount = reviewsMatch[1];
        }

        console.log('Geëxtraheerde waarden:', { score, reviewsCount });
        return { score, reviewsCount };
    }

    // Functie om de score VOOR het product element te injecteren
    function injectTrustScore(score, reviewsCount) {
        // Als de injectie al is uitgevoerd, doe niets
        if (injectionPerformed) {
            return;
        }

        // Controleer of er al een trust-score-container bestaat
        if (document.querySelector('.trust-score-container')) {
            console.log('Trustpilot score is al geïnjecteerd');
            injectionPerformed = true;
            return;
        }

        const productElement = document.querySelector('.product-123');

        if (productElement) {
            const trustScoreDiv = document.createElement('div');
            trustScoreDiv.className = 'trust-score-container';

            // HTML samenstellen met de afbeeldingen in een aparte div
            trustScoreDiv.innerHTML = `
                <div class="trust-images-container">
                    <img class="trustpilot-logo" src="https://cdn.shopify.com/s/files/1/0759/0379/5515/files/trustpilot2525-removebg-preview.png?v=1709682595">
                    <img class="trustpilot-stars" src="https://cdn.trustpilot.net/brand-assets/4.1.0/stars/stars-5.svg">
                </div>
                <div class="trust-score-text">
                    Trustscore <strong>${score}</strong> | ${reviewsCount} reviews
                </div>
            `;

            // Injecteren VOOR het product element
            productElement.insertAdjacentElement('beforebegin', trustScoreDiv);
            console.log('Trustpilot score succesvol geïnjecteerd voor het product element');

            // Markeer dat de injectie is uitgevoerd
            injectionPerformed = true;
        } else {
            console.warn('Geen element met klasse "product" gevonden om de Trustpilot score voor te injecteren');
        }
    }

    // Functie om de injectie te starten
    function initTrustpilotInjection() {
        if (!injectionPerformed) {
            const data = extractTrustpilotData();
            injectTrustScore(data.score, data.reviewsCount);
        }
    }

    // Event listener voor DOMContentLoaded
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initTrustpilotInjection);
    } else {
        // Voor pagina's die al geladen zijn
        initTrustpilotInjection();
    }
})();

function calculateHMSleft() {
 const now = new Date();
 const hoursleft = 23 - now.getHours();
 const minutesleft = 59 - now.getMinutes();
 const secondsleft = 59 - now.getSeconds();
 const totalSecondsLeft = hoursleft * 3600 + minutesleft * 60 + secondsleft;
 const remainingTime = formatTime(totalSecondsLeft);
 updateElements(remainingTime);
}

function formatTime(totalSecondsLeft) {
 if (totalSecondsLeft >= 86400) return "meer dan 1 dag";
 
 const hours = Math.floor(totalSecondsLeft / 3600);
 const minutes = Math.floor((totalSecondsLeft % 3600) / 60);
 const seconds = totalSecondsLeft % 60;
 
 let timeString = '';
 if (hours > 0) timeString += `${hours}u `;
 if (minutes > 0 || hours > 0) timeString += `${minutes}m `;
 timeString += `${seconds}s`;
 
 return timeString;
}

function updateElements(remainingTime) {
 document.querySelectorAll("#HMSremaining").forEach(element => {
   const existingContent = element.innerHTML;
   const parentDiv = element.closest('.voorraadmelding');
   
   if (!parentDiv) return;
   
   const meldingClass = Array.from(parentDiv.classList).find(className => className.startsWith('voorraadmelding-'));
   if (!meldingClass) return;
   
   const meldingNumber = parseInt(meldingClass.split('-')[1]);
   
   if ([4, 5].includes(meldingNumber)) {
     element.innerHTML = remainingTime;
   } else {
     if (!existingContent.includes("Bestel in de komende")) {
       element.innerHTML = `${existingContent}Bestel in de komende <strong>${remainingTime}</strong> en je bestelling wordt <strong>vandaag verzonden</strong>.`;
     } else {
       element.querySelector("strong").innerHTML = remainingTime;
     }
   }
 });
}

function handleStockReminders() {
 document.querySelectorAll("#stock-reminder").forEach(stockReminder => {
   const sqzlyElement = stockReminder.closest(".sqzly-320");
   if (sqzlyElement) {
     const observer = new MutationObserver(() => {
       sqzlyElement.style.display = stockReminder.classList.contains("d-none") ? "" : "none";
     });
     
     observer.observe(stockReminder, { attributes: true });
     sqzlyElement.style.display = stockReminder.classList.contains("d-none") ? "" : "none";
   }
 });
}

calculateHMSleft();
setInterval(calculateHMSleft, 1000);
handleStockReminders();


// PLP / Categoriepagina filters met automatische active status

/**
 * Subcategorieën menu voor QCollection
 * Toont submenu-items als knoppen bovenaan de collectiepagina
 * Met optie om filter te resetten
 * Inclusief H1 titel gebaseerd op collectie
 */
(function () {
    console.log('Script gestart - FINAL VERSION');

    // Controleer of we op een collectiepagina zijn
    if (!window.location.pathname.includes('/collections/')) {
        console.log('Geen collectiepagina, script gestopt');
        return;
    }

    const currentPath = window.location.pathname;
    const currentPathLower = currentPath.toLowerCase(); // Case-insensitive vergelijking
    console.log('Collectiepagina gedetecteerd:', currentPath);

    // Controleer of er al een subcategory-links-container op de pagina staat
    if (document.querySelector('.subcategory-links-container')) {
        console.log('Container bestaat al, script gestopt');
        return;
    }

    // Definieer de categorieën en hun subcategorieën met sterk gescheiden URL-patronen
    const categories = {
        heren: {
            mainUrl: '/collections/mannen',
            uniquePatterns: ['mannen', '-man', 'heren', 'bestsellers-m', '-mannen', 'houtachtige-parfums-heren', 'kruidige-parfums'],
            displayName: 'Heren Parfums',
            subcategories: [
                { text: 'Nieuw', url: '/collections/nieuw-mannen' },
                { text: 'Bestsellers', url: '/collections/bestsellers-m' },
                { text: 'FRIS', url: '/collections/fris-mannen' },
                { text: 'ZOET', url: '/collections/zoet-mannen' },
                { text: 'HOUTACHTIG', url: '/collections/houtachtige-parfums-heren' },
                { text: 'KRUIDIG', url: '/collections/kruidige-parfums' }
            ]
        },
        dames: {
            mainUrl: '/collections/vrouwenn',
            uniquePatterns: ['vrouwenn', 'vrouwen', 'dames', 'bestsellers-v', 'bloemig'],
            displayName: 'Dames Parfums',
            subcategories: [
                { text: 'Nieuw', url: '/collections/nieuw-vrouwen' },
                { text: 'Bestsellers', url: '/collections/bestsellers-v' },
                { text: 'ZOET', url: '/collections/zoet-vrouwen' },
                { text: 'BLOEMIG', url: '/collections/bloemig' },
                { text: 'FRIS', url: '/collections/fris-vrouwen' },
                { text: 'VANILLE', url: '/collections/vanilla-vrouwen' }
            ]
        },
        unisex: {
            mainUrl: '/collections/unisex',
            uniquePatterns: ['unisex', 'bestsellers-u'],
            displayName: 'Unisex Parfums',
            subcategories: [
                { text: 'Nieuw', url: '/collections/unisex-nieuw' },
                { text: 'Bestsellers', url: '/collections/bestsellers-u' },
                { text: 'ZOET', url: '/collections/zoet-unisex' },
                { text: 'HOUTACHTIG', url: '/collections/houtachtig-unisex' },
                { text: 'FRIS', url: '/collections/fris-unisex' },
                { text: 'VANILLE', url: '/collections/vanilla-unisex' }
            ]
        }
    };

    // Voeg alle subcategorieën toe aan unieke patronen
    for (const [category, data] of Object.entries(categories)) {
        data.subcategories.forEach(sub => {
            // Extract collection name from URL path
            const subPath = sub.url.split('/').pop();
            if (!data.uniquePatterns.includes(subPath)) {
                data.uniquePatterns.push(subPath);
            }
        });
    }

    // Debug informatie
    // console.log('Heren patronen:', categories.heren.uniquePatterns);
    // console.log('Dames patronen:', categories.dames.uniquePatterns);
    // console.log('Unisex patronen:', categories.unisex.uniquePatterns);

    // Bepaal tot welke hoofdcategorie de huidige pagina behoort
    let activeCategory = null;
    let activeSubcategories = [];
    let activeSubcategoryIndex = -1;
    let mainCategoryUrl = '';
    let displayName = '';

    // Verbeterde detectie van de actieve categorie
    for (const [category, data] of Object.entries(categories)) {
        // Check elk patroon in de huidige URL
        const matchesPattern = data.uniquePatterns.some(pattern => {
            const match = currentPathLower.includes(pattern.toLowerCase());
            if (match) {
                console.log(`Match gevonden voor categorie ${category} met patroon: ${pattern}`);
            }
            return match;
        });

        if (matchesPattern) {
            activeCategory = category;
            activeSubcategories = data.subcategories;
            mainCategoryUrl = data.mainUrl;
            displayName = data.displayName;

            // Controleer welke subcategorie actief is - exact URL vergelijking
            data.subcategories.forEach((sub, index) => {
                // Strict vergelijking - genormaliseerd zonder query parameters
                const normalizedSubUrl = sub.url.toLowerCase().split('?')[0];
                const normalizedCurrentPath = currentPathLower.split('?')[0];

                if (normalizedCurrentPath === normalizedSubUrl) {
                    activeSubcategoryIndex = index;
                    console.log(`Actieve subcategorie gevonden: ${sub.text} (index ${index})`);
                }
            });

            break;
        }
    }

    // Als we geen actieve categorie hebben gevonden, stop dan
    if (!activeCategory) {
        console.log('Geen bijpassende categorie gevonden voor dit pad, script gestopt');
        return;
    }

    // console.log('Actieve categorie:', activeCategory);
    // console.log('Aantal subcategorieën:', activeSubcategories.length);
    // console.log('Display naam:', displayName);

    // Maak een container wrapper voor zowel de H1 als de subcategorie links
    const wrapper = document.createElement('div');
    wrapper.className = 'category-header-wrapper';
    wrapper.setAttribute('data-category', activeCategory);

    // Maak een H1 element aan
    const titleElement = document.createElement('h1');
    titleElement.className = 'collection-title';
    titleElement.textContent = displayName || 'Parfums';
    wrapper.appendChild(titleElement);

    // Maak de container voor de subcategorie links
    const container = document.createElement('div');
    container.className = 'subcategory-links-container';

    // Normaliseer huidige URL voor vergelijking
    const currentPathNormalized = currentPath.toLowerCase().split('?')[0];

    // Voeg eerst de reset-knop toe (Alle parfums)
    const resetButton = document.createElement('a');
    resetButton.href = mainCategoryUrl;
    resetButton.className = 'category-button reset-button';
    resetButton.setAttribute('data-category', activeCategory);
    resetButton.setAttribute('data-type', 'reset');

    // Alleen actief markeren als het EXACT de hoofdcategorie URL is
    const mainCategoryPath = mainCategoryUrl.toLowerCase().split('?')[0];
    const isResetActive = currentPathNormalized === mainCategoryPath;

    if (isResetActive) {
        resetButton.className += ' active';
        console.log('Reset knop is actief');
    }

    // Voeg een kruisje toe voor de reset button
    const resetIcon = document.createElement('span');
    resetIcon.className = 'reset-icon';
    resetIcon.innerHTML = '×';

    resetButton.appendChild(resetIcon);
    resetButton.appendChild(document.createTextNode(' Alle parfums'));
    container.appendChild(resetButton);

    // Indicator voor debuggen - slaat op of er een actieve knop is gevonden
    let activeButtonFound = isResetActive;

    // Voeg knoppen toe voor elke subcategorie
    activeSubcategories.forEach((link, index) => {
        const button = document.createElement('a');
        button.href = link.url;
        button.className = 'category-button';
        button.setAttribute('data-category', activeCategory);
        button.setAttribute('data-index', index);

        // Controleer of deze subcategorie actief is - exact URL vergelijking
        const normalizedLinkUrl = link.url.toLowerCase().split('?')[0];
        const isActive = currentPathNormalized === normalizedLinkUrl;

        if (isActive) {
            button.className += ' active';
            activeButtonFound = true;
            console.log('Actieve knop gemarkeerd:', link.text, 'met URL:', link.url);
        }

        // Converteer tekst naar eerste letter hoofdletter, rest kleine letters
        const formattedText = link.text.charAt(0).toUpperCase() + link.text.slice(1).toLowerCase();
        button.textContent = formattedText;

        container.appendChild(button);
    });

    // Als er geen actieve knop is gevonden, maar we weten dat de pagina tot deze categorie behoort,
    // voeg dan een console-waarschuwing toe
    if (!activeButtonFound) {
        console.warn('Geen actieve knop gevonden voor de huidige pagina, maar categorie is wel correct gedetecteerd');
    }

    // Verwijder eventuele dubbele actieve knoppen (voor de zekerheid)
    const removeAnyDuplicateActiveButtons = () => {
        const allButtons = container.querySelectorAll('.category-button');
        const activeButtons = container.querySelectorAll('.category-button.active');

        if (activeButtons.length > 1) {
            console.warn(`Meerdere actieve knoppen gedetecteerd (${activeButtons.length}), dubbele activiteit wordt gerepareerd`);

            // Controleer of er een exacte URL-match is
            let exactMatchFound = false;

            activeButtons.forEach(button => {
                const buttonUrl = button.getAttribute('href').toLowerCase().split('?')[0];
                if (buttonUrl === currentPathNormalized) {
                    exactMatchFound = true;
                    console.log('Exacte URL match gevonden voor:', buttonUrl);
                }
            });

            // Als er een exacte match is, verwijder actieve status van alle niet-exacte matches
            if (exactMatchFound) {
                activeButtons.forEach(button => {
                    const buttonUrl = button.getAttribute('href').toLowerCase().split('?')[0];
                    if (buttonUrl !== currentPathNormalized) {
                        button.classList.remove('active');
                        console.log('Actieve status verwijderd van niet-exacte match:', buttonUrl);
                    }
                });
            }
            // Anders, behoud alleen de eerste actieve knop
            else {
                for (let i = 1; i < activeButtons.length; i++) {
                    activeButtons[i].classList.remove('active');
                    console.log('Actieve status verwijderd van dubbele knop');
                }
            }
        }
    };

    // Roep functie aan om dubbele actieve knoppen te verwijderen
    removeAnyDuplicateActiveButtons();

    // Voeg container toe aan wrapper
    wrapper.appendChild(container);

    // Voeg debug info toe aan de pagina (alleen in ontwikkeling)
    const debugInfo = document.createElement('div');
    debugInfo.style.display = 'none'; // Verborgen in productie
    debugInfo.className = 'debug-info';
    debugInfo.innerHTML = `
        <p>Categorie: ${activeCategory}</p>
        <p>Huidige URL: ${currentPath}</p>
        <p>Genormaliseerde URL: ${currentPathNormalized}</p>
        <p>Aantal subcategorieën: ${activeSubcategories.length}</p>
        <p>Actieve subcategorie index: ${activeSubcategoryIndex}</p>
        <p>Actieve knop gevonden: ${activeButtonFound}</p>
    `;
    wrapper.appendChild(debugInfo);

    // Link naar de CSS op het niveau van de hoofdpagina
    const linkElement = document.createElement('link');
    linkElement.rel = 'stylesheet';
    linkElement.href = '/subcategory-menu.css';
    document.head.appendChild(linkElement);

    // Zoek een geschikte plek om het menu toe te voegen
    // Probeer verschillende opties
    const options = [
        '.shopify-section--main-collection',  // Specifieke collectie sectie
        '.shopify-section-main-collection',   // Alternatieve naamgeving
        '.collection',                        // Mogelijke collectie container
        '.page-width',                        // Mogelijke pagina container
        'main',                              // Main element
        '.main-content'                      // Andere mogelijke container
    ];

    let inserted = false;

    for (const selector of options) {
        const element = document.querySelector(selector);
        if (element) {
            console.log('Element gevonden voor injectie:', selector);

            if (element.firstChild) {
                element.insertBefore(wrapper, element.firstChild);
            } else {
                element.appendChild(wrapper);
            }

            inserted = true;
            console.log('Header en menu succesvol toegevoegd aan', selector);
            break;
        }
    }

    // Als geen van de opties werkt, voeg toe aan body
    if (!inserted) {
        console.log('Geen specifiek element gevonden, toevoegen aan body');
        document.body.insertBefore(wrapper, document.body.firstChild);
    }

    // Voeg een final check toe om na het injecteren eventuele dubbele actieve knoppen te verwijderen
    setTimeout(() => {
        const activeButtons = document.querySelectorAll('.category-button.active');
        if (activeButtons.length > 1) {
            console.warn(`Na injectie: ${activeButtons.length} actieve knoppen gevonden, opschonen...`);
            removeAnyDuplicateActiveButtons();
        } else {
            console.log('Geen dubbele actieve knoppen gevonden na injectie');
        }
    }, 100);

    console.log('Script succesvol voltooid');
})();